export default __webpack_public_path__ + "static/media/vectorLeft.c4c08cb5.svg";